import React, { FC } from "react"
import _ from "lodash"
import { RouteComponentProps } from "@reach/router"
import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"

const Hospitality: FC<RouteComponentProps> = (props) => {
  const tabs = [
    {name: "Rooms", link: "/n/hospitality/rooms", hard: false},
    {name: "Line Items", link: "/n/hospitality/line-items", hard: false},
    {name: "Departmental", link: "/n/hospitality/departmental-line-items", hard: false},
    {name: "Inflation", link: "/n/hospitality/inflation", hard: false},
    {name: "Area Measures", link: "/n/hospitality/area-measure", hard: false},
  ]

  return (
    <Container_s>
      <Subnav section="HOSPITALITY" tabs={tabs}/>
      <Content_s>
        { props.children }
      </Content_s>
    </Container_s>
  )
}

export default Hospitality
